import { initI18n } from 'www/utils'
import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import ReviewCardTooltips from 'www/vue_components/common/ReviewCardTooltips/ReviewCardTooltips.vue'
import I18NextVue from 'i18next-vue'

async function init() {
  const { i18next } = await initI18n({ bundle: 'vue_components/common/ReviewCardTooltips' })
  const mountElements = [...document.querySelectorAll('.b-review-card:not(.d-none) .vue-review-card-tooltips-mount')]

  Vue.use(I18NextVue, { i18next })

  mountElements.forEach(mountElement => {
    mountElement.classList = ''

    new Vue({
      vuetify,
      el: mountElement,
      components: { ReviewCardTooltips },
    })
  })
}

/**
 * setTimeout используется для небольшого ускорения загрузки страницы,
 * чтобы рендер компонентов вызывался не блокирующе (асинхронно)
 */
setTimeout(init)
